
import React from 'react'

function Card() {
  return (
    <div><div className="elementor-container elementor-column-gap-no">
    <div
      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7c56ca5"
      data-id="7c56ca5"
      data-element_type="column"
    >
      <div className="elementor-widget-wrap elementor-element-populated">
        <section
          className="elementor-section elementor-inner-section elementor-element elementor-element-7c0a35b animated-fast elementor-section-boxed elementor-section-height-default elementor-section-height-default animated bounceInUp"
          data-id="7c0a35b"
          data-element_type="section"
          data-settings='{"animation":"bounceInUp","animation_delay":100,"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
        >
          <div className="elementor-container elementor-column-gap-no">
            <div
              className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-c93d46a"
              data-id="c93d46a"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-aa93585 elementor-widget__width-auto elementor-absolute wdt-spiral-arrow-style e-transform elementor-hidden-tablet_extra elementor-hidden-tablet elementor-hidden-mobile_extra elementor-hidden-mobile animated-fast elementor-view-default elementor-widget elementor-widget-icon animated bounceInLeft"
                  data-id="aa93585"
                  data-element_type="widget"
                  data-settings='{"_position":"absolute","wdt_animation_effect":"mouse-move","wdt_mme_depth":{"unit":"dpt","size":0.3,"sizes":[]},"wdt_mme_invert_movement":"true","_transform_flipX_effect":"transform","_animation":"bounceInLeft","_animation_delay":500,"wdt_mme_speed":{"unit":"ms","size":0.1,"sizes":[]},"wdt_mme_speed_laptop":{"unit":"px","size":"","sizes":[]},"wdt_mme_speed_tablet_extra":{"unit":"px","size":"","sizes":[]},"wdt_mme_speed_tablet":{"unit":"px","size":"","sizes":[]},"wdt_mme_speed_mobile_extra":{"unit":"px","size":"","sizes":[]},"wdt_mme_speed_mobile":{"unit":"px","size":"","sizes":[]},"wdt_mme_depth_laptop":{"unit":"px","size":"","sizes":[]},"wdt_mme_depth_tablet_extra":{"unit":"px","size":"","sizes":[]},"wdt_mme_depth_tablet":{"unit":"px","size":"","sizes":[]},"wdt_mme_depth_mobile_extra":{"unit":"px","size":"","sizes":[]},"wdt_mme_depth_mobile":{"unit":"px","size":"","sizes":[]},"wdt_mme_move_along":"both"}'
                  data-widget_type="icon.default"
                  style={{
                    transform: "translate3d(0px, 0px, 0px)",
                    transformStyle: "preserve-3d",
                    backfaceVisibility: "hidden"
                  }}
                >
                  <div className="elementor-widget-container">
                    <div
                      className="wdt-effect-mouse-move-wrapper layer"
                      data-depth="0.3"
                      style={{
                        position: "relative",
                        display: "block",
                        left: 0,
                        top: 0,
                        transform: "translate3d(4.26797px, -5.56218px, 0px)",
                        transformStyle: "preserve-3d",
                        backfaceVisibility: "hidden"
                      }}
                    >
                      <div className="elementor-icon-wrapper">
                        <div className="elementor-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            
                            x="0px"
                            y="0px"
                            viewBox="0 0 100 100"
                            style={{ enableBackground: "new 0 0 100 100" }}
                     
                          >
                            {" "}
                            <style
                              type="text/css"
                              dangerouslySetInnerHTML={{
                                __html:
                                  "\t.wdt-spiral-line{fill:none;stroke:currentcolor;stroke-width:1.5;stroke-miterlimit:10;}\t.wdt-spiral-arrow{fill:none;stroke:currentcolor;stroke-width:1.5;stroke-miterlimit:10;}\t"
                              }}
                            />{" "}
                            <path
                              className="wdt-spiral-line"
                              d="M66.5,3.8c2.8,2.1,7.2,6,10.7,12.2C79,19.2,81.9,24.6,82,32c0,3.1-0.3,12.8-7.6,20.1c-1.9,1.9-6.1,6.1-12.5,6.6 c-4.5,0.3-8-1.4-9.3-2.2c-5-2.8-7.6-6.5-8.2-8c-1.4-3.2-2.7-8-0.6-11.9c1.5-2.8,4.7-4.6,7.8-4.7c4.9-0.2,8.1,3.8,8.9,4.8 c4.6,5.8,3.1,13.7,2.3,18c-2.3,11.9-9.7,19.6-13.4,23.5c-3.1,3.2-10.5,10.5-22.2,13.5c-3,0.8-5.7,1.1-7.6,1.3"
                            />{" "}
                            <path
                              className="wdt-spiral-arrow"
                              d="M26.3,87.3c-1.1,1.2-2.2,2.1-3.1,2.8c-0.6,0.5-3.2,2.5-4.4,2.9c-0.1,0-0.3,0.1-0.3,0.2c0,0.1,0.8,0.1,1.3,0.2 c1.4,0.2,2.5,0.7,3.3,1c0.5,0.3,1.3,0.7,2,1.3"
                            />
                          </svg>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-ecd974d elementor-widget__width-initial center elementor-widget elementor-widget-wdt-heading"
                  data-id="ecd974d"
                  data-element_type="widget"
                  data-settings='{"wdt_animation_effect":"none"}'
                  data-widget_type="wdt-heading.default"
                >
                  <div className="elementor-widget-container">
                    <div className="wdt-heading-holder" id="wdt-heading-ecd974d">
                      <div className="wdt-heading-subtitle-wrapper wdt-heading-align-center">
                        <span className="wdt-heading-subtitle" >
                          Kids education
                        </span>
                      </div>
                      <h2 className="wdt-heading-title-wrapper wdt-heading-align-center wdt-heading-deco-wrapper">
                        <span className="wdt-heading-title" style={{marginLeft: "1px"}}>
                          Unique Place Where The Magic Of Learning Starts.dh
                        </span>
                      </h2>
                    </div>{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-ef4ae14 elementor-widget__width-auto elementor-absolute elementor-hidden-tablet_extra elementor-hidden-tablet elementor-hidden-mobile_extra elementor-hidden-mobile animated-fast elementor-widget elementor-widget-image animated bounceInRight"
                  data-id="ef4ae14"
                  data-element_type="widget"
                  data-settings='{"_position":"absolute","_animation":"bounceInRight","_animation_delay":500,"wdt_animation_effect":"mouse-move","wdt_mme_depth":{"unit":"dpt","size":0.3,"sizes":[]},"wdt_mme_move_along":"y-axis","wdt_mme_invert_movement":"true","wdt_mme_speed":{"unit":"ms","size":0.1,"sizes":[]},"wdt_mme_speed_laptop":{"unit":"px","size":"","sizes":[]},"wdt_mme_speed_tablet_extra":{"unit":"px","size":"","sizes":[]},"wdt_mme_speed_tablet":{"unit":"px","size":"","sizes":[]},"wdt_mme_speed_mobile_extra":{"unit":"px","size":"","sizes":[]},"wdt_mme_speed_mobile":{"unit":"px","size":"","sizes":[]},"wdt_mme_depth_laptop":{"unit":"px","size":"","sizes":[]},"wdt_mme_depth_tablet_extra":{"unit":"px","size":"","sizes":[]},"wdt_mme_depth_tablet":{"unit":"px","size":"","sizes":[]},"wdt_mme_depth_mobile_extra":{"unit":"px","size":"","sizes":[]},"wdt_mme_depth_mobile":{"unit":"px","size":"","sizes":[]}}'
                  data-widget_type="image.default"
                  style={{
                    transform: "translate3d(0px, 0px, 0px)",
                    transformStyle: "preserve-3d",
                    backfaceVisibility: "hidden"
                  }}
                >
                  <div className="elementor-widget-container">
                    <div
                      className="wdt-effect-mouse-move-wrapper layer"
                      data-depth="0.3"
                      style={{
                        position: "relative",
                        display: "block",
                        left: 0,
                        top: 0,
                        transform: "translate3d(0px, -4.44737px, 0px)",
                        transformStyle: "preserve-3d",
                        backfaceVisibility: "hidden"
                      }}
                    >
                      <img
                        loading="lazy"
                        decoding="async"
                        width={800}
                        height={800}
                        src="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/03/pp-1.webp"
                        className="attachment-full size-full wp-image-27445"
                        alt=""
                        srcSet="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/03/pp-1.webp 800w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/03/pp-1-300x300.webp 300w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/03/pp-1-150x150.webp 150w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/03/pp-1-768x768.webp 768w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/03/pp-1-100x100.webp 100w"
                        sizes="(max-width: 800px) 100vw, 800px"
                      />{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-inner-section elementor-element elementor-element-79c3a06 elementor-section-full_width wdt-dark-bg animated-fast elementor-section-height-default elementor-section-height-default animated bounceInUp"
          data-id="79c3a06"
          data-element_type="section"
          data-settings='{"animation":"bounceInUp","animation_delay":100,"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
        >
          <div className="elementor-container elementor-column-gap-no">
            <div
              className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-e7188fd"
              data-id="e7188fd"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-8720383 wdt-custom-education-box-style elementor-widget-tablet_extra__width-initial elementor-widget-mobile_extra__width-initial elementor-widget-mobile__width-inherit center elementor-widget elementor-widget-wdt-image-box"
                  data-id={8720383}
                  data-element_type="widget"
                  data-settings='{"columns":"4","columns_laptop":"4","columns_tablet_extra":"3","button_normal_background_background":"classic","button_hover_background_background":"classic","columns_tablet":2,"columns_mobile_extra":1,"columns_mobile":1,"carousel_arrows_prev_arrow_vertical_top_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_mobile":{"unit":"%","size":"","sizes":[]},"wdt_animation_effect":"none"}'
                  data-widget_type="wdt-image-box.default"
                >
                  <div className="elementor-widget-container">
                    <div
                      className="wdt-image-box-holder wdt-content-item-holder wdt-column-holder wdt-rc-template-custom-template"
                      id="wdt-image-box-8720383"
                      data-settings='{"enable_popup":"","enable_hover_class":""}'
                    >
                      <div
                        className="wdt-column-wrapper wdt-column-gap-custom wdt-snap-scroll-enabled"
                        data-column-settings='{"columnDevices":["tablet_extra","tablet","mobile_extra","mobile"]}'
                        data-module-id="wdt-module-id-8720383"
                        id="wdt-module-id-8720383"
                      >
                        <div className="wdt-column">
                          <div className="wdt-content-item">
                            <div className="wdt-content-media-group">
                              <div className="wdt-content-image-wrapper">
                                <div className="wdt-content-image">
                                  <a href="#" target="_blank" rel="nofollow">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width={800}
                                      height={800}
                                      src="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-104.webp"
                                      className="attachment-full size-full wp-image-24709"
                                      alt=""
                                      srcSet="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-104.webp 800w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-104-300x300.webp 300w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-104-150x150.webp 150w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-104-768x768.webp 768w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-104-100x100.webp 100w"
                                      sizes="(max-width: 800px) 100vw, 800px"
                                    />
                                  </a>
                                </div>
                              </div>
                              <div className="wdt-content-icon-wrapper">
                                <div className="wdt-content-icon">
                                  <span>
                                    <i>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                    
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 382 548"
                                        style={{
                                          enableBackground: "new 0 0 382 548"
                                        }}
                                        
                                      >
                                        {" "}
                                        <style
                                          type="text/css"
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              "\t.education-box-0{fill:none;stroke:#000000;stroke-miterlimit:10;}\t.education-box-1{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:12.185,5.0771;}\t.education-box-2{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:11.6867,4.8695;}\t.education-box-3{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:11.9572,4.9822;}\t.education-box-4{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:11.5762,4.8234;}\t"
                                          }}
                                        />{" "}
                                        <g>
                                          {" "}
                                          <path d="M377.4,285.7v55.8c-0.3,2-0.9,4-1,6c-2,28.9-3.4,57.8-5.9,86.6c-3.2,36.6-10.1,72.6-18.7,108.4H36.9  c-0.3-1.3-0.4-2.5-0.8-3.8C16.8,479.3,7.6,418.2,5.8,355.9c-0.1-3.3-0.7-6.6-1.1-9.9c0-15.6,0-31.3,0-46.9c0.3-1.6,0.9-3.2,0.9-4.9  c1.3-23.2,2.1-46.4,3.8-69.6c1.9-25.6,4.5-51.1,7.1-76.6c2.6-25.9,5.6-51.7,8.5-77.5c1-9.4,2.1-18.8,3-27.6c0.9-0.7,1.1-1,1.4-1.2  c42.8-17.1,86.8-29.6,132.9-33.9c7.9-0.7,15.8-1.6,23.7-2.4c9.3,0,18.5,0,27.8,0c5.5,0.5,11,1,16.5,1.5  c43.6,3.8,85.6,14.4,126.2,30.8c1.7,0.7,3.3,1.5,4.5,2.1c2.8,35.3,5.9,69.9,8.1,104.6c2.8,44.5,4.9,89.1,7.3,133.6  C376.5,280.6,377,283.2,377.4,285.7L377.4,285.7z" />{" "}
                                          <g>
                                            {" "}
                                            <path
                                              className="education-box-0"
                                              d="M376.5,279.8c0.2,2,0.6,4,0.8,5.9l0,0v6"
                                            />{" "}
                                            <path
                                              className="education-box-1"
                                              d="M377.4,296.8v44.7c-0.3,2-0.9,4-1,6c-2,28.9-3.4,57.8-5.9,86.6c-3,33.8-9.1,67.1-16.7,100.1"
                                            />{" "}
                                            <path
                                              className="education-box-0"
                                              d="M353.2,536.7c-0.5,1.9-0.9,3.9-1.4,5.8h-6"
                                            />{" "}
                                            <line
                                              className="education-box-2"
                                              x1="340.9"
                                              y1="542.5"
                                              x2="45.3"
                                              y2="542.5"
                                            />{" "}
                                            <path
                                              className="education-box-0"
                                              d="M42.9,542.5h-6c-0.3-1.3-0.4-2.5-0.8-3.8c-0.2-0.7-0.4-1.4-0.7-2.1"
                                            />{" "}
                                            <path
                                              className="education-box-3"
                                              d="M34,531.9c-17.8-57.3-26.4-116.1-28.2-176c-0.1-3.3-0.7-6.6-1.1-9.9c0-15.6,0-31.3,0-46.9   c0.3-1.6,0.9-3.2,0.9-4.9c1.3-23.2,2.1-46.4,3.8-69.6c1.9-25.6,4.5-51.1,7.1-76.6c2.6-25.9,5.6-51.7,8.5-77.5   c1-9.4,2.1-18.8,3-27.6c0.9-0.7,1.1-1,1.4-1.2c42.8-17.1,86.8-29.6,132.9-33.9c7.9-0.7,15.8-1.6,23.7-2.4c9.3,0,18.5,0,27.8,0   c5.5,0.5,11,1,16.5,1.5c42.4,3.7,83.3,13.8,122.9,29.5"
                                            />{" "}
                                            <path
                                              className="education-box-0"
                                              d="M355.5,37.4c0.3,0.1,0.7,0.3,1,0.4c1.7,0.7,3.3,1.5,4.5,2.1c0.2,2,0.3,4,0.5,6"
                                            />{" "}
                                            <path
                                              className="education-box-4"
                                              d="M361.8,50.7c2.5,31.6,5.3,62.7,7.3,93.8c2.8,44.3,4.8,88.6,7.3,132.9"
                                            />{" "}
                                          </g>{" "}
                                        </g>
                                      </svg>
                                    </i>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="wdt-content-detail-group">
                              <div className="wdt-content-title">
                                <h5>
                                  <a href="#" target="_blank" rel="nofollow">
                                    Activity Classroom{" "}
                                  </a>
                                </h5>
                              </div>
                              <div className="wdt-content-description">
                                Semper feugiat nibh sed pulvinar proin gravida.
                                Aliquam eleifend mi in nulla. In pellentesque
                                massa placerat duis ultricies. Lorem ipsum dolor
                                sit amet consectetur adipiscing elit ut.{" "}
                              </div>
                              <div className="wdt-content-button wdt-button-clone">
                                <a href="#" target="_blank" rel="nofollow">
                                  <div className="wdt-button-text">
                                    <span>Get Started</span>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="wdt-column">
                          <div className="wdt-content-item">
                            <div className="wdt-content-media-group">
                              <div className="wdt-content-image-wrapper">
                                <div className="wdt-content-image">
                                  <a href="#" target="_blank" rel="nofollow">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width={800}
                                      height={800}
                                      src="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-103.webp"
                                      className="attachment-full size-full wp-image-24710"
                                      alt=""
                                      srcSet="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-103.webp 800w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-103-300x300.webp 300w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-103-150x150.webp 150w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-103-768x768.webp 768w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-103-100x100.webp 100w"
                                      sizes="(max-width: 800px) 100vw, 800px"
                                    />
                                  </a>
                                </div>
                              </div>
                              <div className="wdt-content-icon-wrapper">
                                <div className="wdt-content-icon">
                                  <span>
                                    <i>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                      
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 382 548"
                                        style={{
                                          enableBackground: "new 0 0 382 548"
                                        }}
                                     
                                      >
                                        {" "}
                                        <style
                                          type="text/css"
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              "\t.education-box-0{fill:none;stroke:#000000;stroke-miterlimit:10;}\t.education-box-1{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:12.185,5.0771;}\t.education-box-2{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:11.6867,4.8695;}\t.education-box-3{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:11.9572,4.9822;}\t.education-box-4{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:11.5762,4.8234;}\t"
                                          }}
                                        />{" "}
                                        <g>
                                          {" "}
                                          <path d="M377.4,285.7v55.8c-0.3,2-0.9,4-1,6c-2,28.9-3.4,57.8-5.9,86.6c-3.2,36.6-10.1,72.6-18.7,108.4H36.9  c-0.3-1.3-0.4-2.5-0.8-3.8C16.8,479.3,7.6,418.2,5.8,355.9c-0.1-3.3-0.7-6.6-1.1-9.9c0-15.6,0-31.3,0-46.9c0.3-1.6,0.9-3.2,0.9-4.9  c1.3-23.2,2.1-46.4,3.8-69.6c1.9-25.6,4.5-51.1,7.1-76.6c2.6-25.9,5.6-51.7,8.5-77.5c1-9.4,2.1-18.8,3-27.6c0.9-0.7,1.1-1,1.4-1.2  c42.8-17.1,86.8-29.6,132.9-33.9c7.9-0.7,15.8-1.6,23.7-2.4c9.3,0,18.5,0,27.8,0c5.5,0.5,11,1,16.5,1.5  c43.6,3.8,85.6,14.4,126.2,30.8c1.7,0.7,3.3,1.5,4.5,2.1c2.8,35.3,5.9,69.9,8.1,104.6c2.8,44.5,4.9,89.1,7.3,133.6  C376.5,280.6,377,283.2,377.4,285.7L377.4,285.7z" />{" "}
                                          <g>
                                            {" "}
                                            <path
                                              className="education-box-0"
                                              d="M376.5,279.8c0.2,2,0.6,4,0.8,5.9l0,0v6"
                                            />{" "}
                                            <path
                                              className="education-box-1"
                                              d="M377.4,296.8v44.7c-0.3,2-0.9,4-1,6c-2,28.9-3.4,57.8-5.9,86.6c-3,33.8-9.1,67.1-16.7,100.1"
                                            />{" "}
                                            <path
                                              className="education-box-0"
                                              d="M353.2,536.7c-0.5,1.9-0.9,3.9-1.4,5.8h-6"
                                            />{" "}
                                            <line
                                              className="education-box-2"
                                              x1="340.9"
                                              y1="542.5"
                                              x2="45.3"
                                              y2="542.5"
                                            />{" "}
                                            <path
                                              className="education-box-0"
                                              d="M42.9,542.5h-6c-0.3-1.3-0.4-2.5-0.8-3.8c-0.2-0.7-0.4-1.4-0.7-2.1"
                                            />{" "}
                                            <path
                                              className="education-box-3"
                                              d="M34,531.9c-17.8-57.3-26.4-116.1-28.2-176c-0.1-3.3-0.7-6.6-1.1-9.9c0-15.6,0-31.3,0-46.9   c0.3-1.6,0.9-3.2,0.9-4.9c1.3-23.2,2.1-46.4,3.8-69.6c1.9-25.6,4.5-51.1,7.1-76.6c2.6-25.9,5.6-51.7,8.5-77.5   c1-9.4,2.1-18.8,3-27.6c0.9-0.7,1.1-1,1.4-1.2c42.8-17.1,86.8-29.6,132.9-33.9c7.9-0.7,15.8-1.6,23.7-2.4c9.3,0,18.5,0,27.8,0   c5.5,0.5,11,1,16.5,1.5c42.4,3.7,83.3,13.8,122.9,29.5"
                                            />{" "}
                                            <path
                                              className="education-box-0"
                                              d="M355.5,37.4c0.3,0.1,0.7,0.3,1,0.4c1.7,0.7,3.3,1.5,4.5,2.1c0.2,2,0.3,4,0.5,6"
                                            />{" "}
                                            <path
                                              className="education-box-4"
                                              d="M361.8,50.7c2.5,31.6,5.3,62.7,7.3,93.8c2.8,44.3,4.8,88.6,7.3,132.9"
                                            />{" "}
                                          </g>{" "}
                                        </g>
                                      </svg>
                                    </i>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="wdt-content-detail-group">
                              <div className="wdt-content-title">
                                <h5>
                                  <a href="#" target="_blank" rel="nofollow">
                                    Play Classroom
                                  </a>
                                </h5>
                              </div>
                              <div className="wdt-content-description">
                                Tortor pretium viverra suspendisse potenti nullam
                                ac tortor vitae. Metus aliquam eleifend mi in
                                nulla posuere sollicitudin aliquam ultrices. Nunc
                                eget lorem dolor sed. Rutrum quisque.{" "}
                              </div>
                              <div className="wdt-content-button wdt-button-clone">
                                <a href="#" target="_blank" rel="nofollow">
                                  <div className="wdt-button-text">
                                    <span>Get Started</span>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="wdt-column">
                          <div className="wdt-content-item">
                            <div className="wdt-content-media-group">
                              <div className="wdt-content-image-wrapper">
                                <div className="wdt-content-image">
                                  <a href="#" target="_blank" rel="nofollow">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width={800}
                                      height={800}
                                      src="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-102.webp"
                                      className="attachment-full size-full wp-image-24711"
                                      alt=""
                                      srcSet="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-102.webp 800w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-102-300x300.webp 300w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-102-150x150.webp 150w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-102-768x768.webp 768w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-102-100x100.webp 100w"
                                      sizes="(max-width: 800px) 100vw, 800px"
                                    />
                                  </a>
                                </div>
                              </div>
                              <div className="wdt-content-icon-wrapper">
                                <div className="wdt-content-icon">
                                  <span>
                                    <i>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        // xmlnsXlink="http://www.w3.org/1999/xlink"
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 382 548"
                                        style={{
                                          enableBackground: "new 0 0 382 548"
                                        }}
                                        // xmlSpace="preserve"
                                      >
                                        {" "}
                                        <style
                                          type="text/css"
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              "\t.education-box-0{fill:none;stroke:#000000;stroke-miterlimit:10;}\t.education-box-1{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:12.185,5.0771;}\t.education-box-2{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:11.6867,4.8695;}\t.education-box-3{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:11.9572,4.9822;}\t.education-box-4{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:11.5762,4.8234;}\t"
                                          }}
                                        />{" "}
                                        <g>
                                          {" "}
                                          <path d="M377.4,285.7v55.8c-0.3,2-0.9,4-1,6c-2,28.9-3.4,57.8-5.9,86.6c-3.2,36.6-10.1,72.6-18.7,108.4H36.9  c-0.3-1.3-0.4-2.5-0.8-3.8C16.8,479.3,7.6,418.2,5.8,355.9c-0.1-3.3-0.7-6.6-1.1-9.9c0-15.6,0-31.3,0-46.9c0.3-1.6,0.9-3.2,0.9-4.9  c1.3-23.2,2.1-46.4,3.8-69.6c1.9-25.6,4.5-51.1,7.1-76.6c2.6-25.9,5.6-51.7,8.5-77.5c1-9.4,2.1-18.8,3-27.6c0.9-0.7,1.1-1,1.4-1.2  c42.8-17.1,86.8-29.6,132.9-33.9c7.9-0.7,15.8-1.6,23.7-2.4c9.3,0,18.5,0,27.8,0c5.5,0.5,11,1,16.5,1.5  c43.6,3.8,85.6,14.4,126.2,30.8c1.7,0.7,3.3,1.5,4.5,2.1c2.8,35.3,5.9,69.9,8.1,104.6c2.8,44.5,4.9,89.1,7.3,133.6  C376.5,280.6,377,283.2,377.4,285.7L377.4,285.7z" />{" "}
                                          <g>
                                            {" "}
                                            <path
                                              className="education-box-0"
                                              d="M376.5,279.8c0.2,2,0.6,4,0.8,5.9l0,0v6"
                                            />{" "}
                                            <path
                                              className="education-box-1"
                                              d="M377.4,296.8v44.7c-0.3,2-0.9,4-1,6c-2,28.9-3.4,57.8-5.9,86.6c-3,33.8-9.1,67.1-16.7,100.1"
                                            />{" "}
                                            <path
                                              className="education-box-0"
                                              d="M353.2,536.7c-0.5,1.9-0.9,3.9-1.4,5.8h-6"
                                            />{" "}
                                            <line
                                              className="education-box-2"
                                              x1="340.9"
                                              y1="542.5"
                                              x2="45.3"
                                              y2="542.5"
                                            />{" "}
                                            <path
                                              className="education-box-0"
                                              d="M42.9,542.5h-6c-0.3-1.3-0.4-2.5-0.8-3.8c-0.2-0.7-0.4-1.4-0.7-2.1"
                                            />{" "}
                                            <path
                                              className="education-box-3"
                                              d="M34,531.9c-17.8-57.3-26.4-116.1-28.2-176c-0.1-3.3-0.7-6.6-1.1-9.9c0-15.6,0-31.3,0-46.9   c0.3-1.6,0.9-3.2,0.9-4.9c1.3-23.2,2.1-46.4,3.8-69.6c1.9-25.6,4.5-51.1,7.1-76.6c2.6-25.9,5.6-51.7,8.5-77.5   c1-9.4,2.1-18.8,3-27.6c0.9-0.7,1.1-1,1.4-1.2c42.8-17.1,86.8-29.6,132.9-33.9c7.9-0.7,15.8-1.6,23.7-2.4c9.3,0,18.5,0,27.8,0   c5.5,0.5,11,1,16.5,1.5c42.4,3.7,83.3,13.8,122.9,29.5"
                                            />{" "}
                                            <path
                                              className="education-box-0"
                                              d="M355.5,37.4c0.3,0.1,0.7,0.3,1,0.4c1.7,0.7,3.3,1.5,4.5,2.1c0.2,2,0.3,4,0.5,6"
                                            />{" "}
                                            <path
                                              className="education-box-4"
                                              d="M361.8,50.7c2.5,31.6,5.3,62.7,7.3,93.8c2.8,44.3,4.8,88.6,7.3,132.9"
                                            />{" "}
                                          </g>{" "}
                                        </g>
                                      </svg>
                                    </i>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="wdt-content-detail-group">
                              <div className="wdt-content-title">
                                <h5>
                                  <a href="#" target="_blank" rel="nofollow">
                                    Computer Classroom
                                  </a>
                                </h5>
                              </div>
                              <div className="wdt-content-description">
                                Dolor sed viverra ipsum nunc aliquet bibendum enim
                                facilisis gravida. Lacus luctus accumsan tortor
                                posuere ac ut. Elementum facilisis leo vel
                                fringilla est ullamcorper. neque aliquam
                                vestibulum.
                              </div>
                              <div className="wdt-content-button wdt-button-clone">
                                <a href="#" target="_blank" rel="nofollow">
                                  <div className="wdt-button-text">
                                    <span>Get Started</span>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="wdt-column">
                          <div className="wdt-content-item">
                            <div className="wdt-content-media-group">
                              <div className="wdt-content-image-wrapper">
                                <div className="wdt-content-image">
                                  <a href="#" target="_blank" rel="nofollow">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width={800}
                                      height={800}
                                      src="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-101.webp"
                                      className="attachment-full size-full wp-image-24715"
                                      alt=""
                                      srcSet="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-101.webp 800w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-101-300x300.webp 300w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-101-150x150.webp 150w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-101-768x768.webp 768w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/home-2-image-101-100x100.webp 100w"
                                      sizes="(max-width: 800px) 100vw, 800px"
                                    />
                                  </a>
                                </div>
                              </div>
                              <div className="wdt-content-icon-wrapper">
                                <div className="wdt-content-icon">
                                  <span>
                                    <i>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        // xmlnsXlink="http://www.w3.org/1999/xlink"
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 382 548"
                                        style={{
                                          enableBackground: "new 0 0 382 548"
                                        }}
                                        // xmlSpace="preserve"
                                      >
                                        {" "}
                                        <style
                                          type="text/css"
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              "\t.education-box-0{fill:none;stroke:#000000;stroke-miterlimit:10;}\t.education-box-1{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:12.185,5.0771;}\t.education-box-2{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:11.6867,4.8695;}\t.education-box-3{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:11.9572,4.9822;}\t.education-box-4{fill:none;stroke:#000000;stroke-miterlimit:10;stroke-dasharray:11.5762,4.8234;}\t"
                                          }}
                                        />{" "}
                                        <g>
                                          {" "}
                                          <path d="M377.4,285.7v55.8c-0.3,2-0.9,4-1,6c-2,28.9-3.4,57.8-5.9,86.6c-3.2,36.6-10.1,72.6-18.7,108.4H36.9  c-0.3-1.3-0.4-2.5-0.8-3.8C16.8,479.3,7.6,418.2,5.8,355.9c-0.1-3.3-0.7-6.6-1.1-9.9c0-15.6,0-31.3,0-46.9c0.3-1.6,0.9-3.2,0.9-4.9  c1.3-23.2,2.1-46.4,3.8-69.6c1.9-25.6,4.5-51.1,7.1-76.6c2.6-25.9,5.6-51.7,8.5-77.5c1-9.4,2.1-18.8,3-27.6c0.9-0.7,1.1-1,1.4-1.2  c42.8-17.1,86.8-29.6,132.9-33.9c7.9-0.7,15.8-1.6,23.7-2.4c9.3,0,18.5,0,27.8,0c5.5,0.5,11,1,16.5,1.5  c43.6,3.8,85.6,14.4,126.2,30.8c1.7,0.7,3.3,1.5,4.5,2.1c2.8,35.3,5.9,69.9,8.1,104.6c2.8,44.5,4.9,89.1,7.3,133.6  C376.5,280.6,377,283.2,377.4,285.7L377.4,285.7z" />{" "}
                                          <g>
                                            {" "}
                                            <path
                                              className="education-box-0"
                                              d="M376.5,279.8c0.2,2,0.6,4,0.8,5.9l0,0v6"
                                            />{" "}
                                            <path
                                              className="education-box-1"
                                              d="M377.4,296.8v44.7c-0.3,2-0.9,4-1,6c-2,28.9-3.4,57.8-5.9,86.6c-3,33.8-9.1,67.1-16.7,100.1"
                                            />{" "}
                                            <path
                                              className="education-box-0"
                                              d="M353.2,536.7c-0.5,1.9-0.9,3.9-1.4,5.8h-6"
                                            />{" "}
                                            <line
                                              className="education-box-2"
                                              x1="340.9"
                                              y1="542.5"
                                              x2="45.3"
                                              y2="542.5"
                                            />{" "}
                                            <path
                                              className="education-box-0"
                                              d="M42.9,542.5h-6c-0.3-1.3-0.4-2.5-0.8-3.8c-0.2-0.7-0.4-1.4-0.7-2.1"
                                            />{" "}
                                            <path
                                              className="education-box-3"
                                              d="M34,531.9c-17.8-57.3-26.4-116.1-28.2-176c-0.1-3.3-0.7-6.6-1.1-9.9c0-15.6,0-31.3,0-46.9   c0.3-1.6,0.9-3.2,0.9-4.9c1.3-23.2,2.1-46.4,3.8-69.6c1.9-25.6,4.5-51.1,7.1-76.6c2.6-25.9,5.6-51.7,8.5-77.5   c1-9.4,2.1-18.8,3-27.6c0.9-0.7,1.1-1,1.4-1.2c42.8-17.1,86.8-29.6,132.9-33.9c7.9-0.7,15.8-1.6,23.7-2.4c9.3,0,18.5,0,27.8,0   c5.5,0.5,11,1,16.5,1.5c42.4,3.7,83.3,13.8,122.9,29.5"
                                            />{" "}
                                            <path
                                              className="education-box-0"
                                              d="M355.5,37.4c0.3,0.1,0.7,0.3,1,0.4c1.7,0.7,3.3,1.5,4.5,2.1c0.2,2,0.3,4,0.5,6"
                                            />{" "}
                                            <path
                                              className="education-box-4"
                                              d="M361.8,50.7c2.5,31.6,5.3,62.7,7.3,93.8c2.8,44.3,4.8,88.6,7.3,132.9"
                                            />{" "}
                                          </g>{" "}
                                        </g>
                                      </svg>
                                    </i>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="wdt-content-detail-group">
                              <div className="wdt-content-title">
                                <h5>
                                  <a href="#" target="_blank" rel="nofollow">
                                    Science Lab{" "}
                                  </a>
                                </h5>
                              </div>
                              <div className="wdt-content-description">
                                Rhoncus dolor purus non enim. Libero volutpat sed
                                cras ornare arcu dui vivamus arcu. Lorem mollis
                                aliquam ut porttitor leo a diam. Eros in cursus
                                turpis massa tincidunt.
                              </div>
                              <div className="wdt-content-button wdt-button-clone">
                                <a href="#" target="_blank" rel="nofollow">
                                  <div className="wdt-button-text">
                                    <span>Get Started</span>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="wdt-column-pagination wdt-snap-scroll-pagination"
                        style={{ display: "none" }}
                      >
                        <button className="wdt-pagination-prev wdt-module-id-8720383">
                          Previous
                        </button>
                        <button className="wdt-pagination-next wdt-module-id-8720383">
                          Next
                        </button>
                      </div>
                    </div>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-inner-section elementor-element elementor-element-aeeed5f elementor-section-full_width animated-fast elementor-section-height-default elementor-section-height-default elementor-invisible"
          data-id="aeeed5f"
          data-element_type="section"
          data-settings='{"animation":"bounceInUp","animation_delay":100,"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
        >
          <div className="elementor-container elementor-column-gap-no">
            <div
              className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-0cb23a2 animated-fast elementor-invisible"
              data-id="0cb23a2"
              data-element_type="column"
              data-settings='{"animation":"bounceInLeft","animation_delay":100}'
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-631415f elementor-widget__width-initial animated-fast start elementor-invisible elementor-widget elementor-widget-wdt-heading"
                  data-id="631415f"
                  data-element_type="widget"
                  data-settings='{"_animation":"bounceInUp","_animation_delay":100,"wdt_animation_effect":"none"}'
                  data-widget_type="wdt-heading.default"
                >
                  <div className="elementor-widget-container">
                    <div className="wdt-heading-holder" id="wdt-heading-631415f">
                      <div className="wdt-heading-subtitle-wrapper wdt-heading-align-center">
                        <span className="wdt-heading-subtitle">Our Results</span>
                      </div>
                      <h2 className="wdt-heading-title-wrapper wdt-heading-align-center wdt-heading-deco-wrapper">
                        <span className="wdt-heading-title">
                          We're Proud Of Our Clients &amp; Projects
                        </span>
                      </h2>
                    </div>{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-61aa33c start elementor-widget-mobile_extra__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-wdt-heading"
                  data-id="61aa33c"
                  data-element_type="widget"
                  data-settings='{"wdt_animation_effect":"none"}'
                  data-widget_type="wdt-heading.default"
                >
                  <div className="elementor-widget-container">
                    <div className="wdt-heading-holder" id="wdt-heading-61aa33c">
                      <div className="wdt-heading-content-wrapper">
                        Porttitor massa id neque aliquam vestibulum morbi blandit.
                        Aliquam faucibus purus in massa tempor nec feugiat.
                        Pharetra vel turpis nunc eget libero nunc consequat
                        interdum varius sit amet..
                      </div>
                    </div>{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-399b108 start elementor-widget elementor-widget-wdt-button"
                  data-id="399b108"
                  data-element_type="widget"
                  data-settings='{"item_hover_background_background":"classic","wdt_animation_effect":"none"}'
                  data-widget_type="wdt-button.default"
                >
                  <div className="elementor-widget-container">
                    <div
                      className="wdt-button-holder wdt-template-filled wdt-button-link wdt-button-style-default wdt-button-size-nm wdt-animation- wdt-button-icon-after"
                      id="wdt-button-399b108"
                    >
                      <a className="wdt-button" href="#">
                        <div className="wdt-button-text">
                          <span>Read More</span>
                        </div>
                        <div className="wdt-button-icon">
                          <span>
                            <i>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                // xmlnsXlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                viewBox="0 0 100 100"
                                style={{ enableBackground: "new 0 0 100 100" }}
                                // xmlSpace="preserve"
                              >
                                {" "}
                                <g>
                                  {" "}
                                  <path d="M95.7,49.1c0-0.4-0.1-0.9-0.3-1.3c0-0.2-0.1-0.4-0.1-0.5c-0.1-0.3-0.3-0.8-0.5-1.2c-0.1-0.3-0.4-0.7-0.6-0.9  c-0.3-0.4-0.5-0.7-0.8-0.9c-0.2-0.2-0.6-0.5-0.9-0.7c-0.2-0.1-0.4-0.3-0.8-0.4c0,0,0,0-0.1,0c-0.2-0.1-0.4-0.2-0.6-0.3v0  c-0.1,0-0.2-0.1-0.3-0.1c-3.3-1-11.8-3.8-20.9-7.3C55.2,30,47.7,25.7,46.4,24.2c-2.4-2.8-6.6-2.7-8.9,0c-1.2,1.4-1.8,3.3-1.8,5.2  c0,2,0.7,3.9,1.9,5.3c2.3,2.6,6.3,5.2,11.7,7.8H10.5c-3.5,0-6.3,3.3-6.3,7.4c0,4.1,2.8,7.4,6.3,7.4h38.8c-5.4,2.6-9.5,5.2-11.8,7.8  c-1.2,1.4-1.8,3.3-1.8,5.3c0,2,0.7,3.8,1.8,5.2c1.2,1.4,2.8,2.2,4.5,2.2c1.7,0,3.2-0.8,4.5-2.2c1.2-1.4,8.8-5.7,23.6-11.2  c9.1-3.4,17.6-6.2,20.9-7.2c0.1,0,0.2-0.1,0.3-0.1v0c0.2-0.1,0.4-0.1,0.5-0.2c0.4-0.2,0.6-0.3,0.8-0.4c0.3-0.2,0.7-0.5,0.9-0.7  c0.3-0.3,0.6-0.6,0.8-1c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.4-0.9,0.5-1.3c0.1-0.3,0.2-0.5,0.2-0.8c0.1-0.3,0.1-0.6,0.2-0.9  c0-0.3,0-0.6,0-1C95.8,49.7,95.7,49.4,95.7,49.1z" />{" "}
                                </g>
                              </svg>
                            </i>
                          </span>
                        </div>
                      </a>
                    </div>{" "}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-6225999 elementor-hidden-tablet_extra elementor-hidden-tablet elementor-hidden-mobile_extra elementor-hidden-mobile elementor-widget elementor-widget-image"
                  data-id={6225999}
                  data-element_type="widget"
                  data-settings='{"wdt_animation_effect":"mouse-move","wdt_mme_depth":{"unit":"dpt","size":0.3,"sizes":[]},"wdt_mme_invert_movement":"true","wdt_mme_speed":{"unit":"ms","size":0.1,"sizes":[]},"wdt_mme_speed_laptop":{"unit":"px","size":"","sizes":[]},"wdt_mme_speed_tablet_extra":{"unit":"px","size":"","sizes":[]},"wdt_mme_speed_tablet":{"unit":"px","size":"","sizes":[]},"wdt_mme_speed_mobile_extra":{"unit":"px","size":"","sizes":[]},"wdt_mme_speed_mobile":{"unit":"px","size":"","sizes":[]},"wdt_mme_depth_laptop":{"unit":"px","size":"","sizes":[]},"wdt_mme_depth_tablet_extra":{"unit":"px","size":"","sizes":[]},"wdt_mme_depth_tablet":{"unit":"px","size":"","sizes":[]},"wdt_mme_depth_mobile_extra":{"unit":"px","size":"","sizes":[]},"wdt_mme_depth_mobile":{"unit":"px","size":"","sizes":[]},"wdt_mme_move_along":"both"}'
                  data-widget_type="image.default"
                  style={{
                    transform: "translate3d(0px, 0px, 0px)",
                    transformStyle: "preserve-3d",
                    backfaceVisibility: "hidden"
                  }}
                >
                  <div className="elementor-widget-container">
                    <div
                      className="wdt-effect-mouse-move-wrapper layer"
                      data-depth="0.3"
                      style={{
                        position: "relative",
                        display: "block",
                        left: 0,
                        top: 0,
                        transform: "translate3d(12.4168px, -12.8673px, 0px)",
                        transformStyle: "preserve-3d",
                        backfaceVisibility: "hidden"
                      }}
                    >
                      <img
                        loading="lazy"
                        decoding="async"
                        width={800}
                        height={663}
                        src="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/03/counter-h2-tp-img.webp"
                        className="attachment-full size-full wp-image-27589"
                        alt=""
                        srcSet="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/03/counter-h2-tp-img.webp 800w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/03/counter-h2-tp-img-300x249.webp 300w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/03/counter-h2-tp-img-768x636.webp 768w"
                        sizes="(max-width: 800px) 100vw, 800px"
                      />{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-d9baed5 animated-fast elementor-invisible"
              data-id="d9baed5"
              data-element_type="column"
              data-settings='{"animation":"bounceInRight","animation_delay":100}'
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-0b1e21d wdt-custom-counter1 start elementor-widget-mobile_extra__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-wdt-counter"
                  data-id="0b1e21d"
                  data-element_type="widget"
                  data-settings='{"columns":"2","columns_laptop":"2","columns_tablet_extra":"2","columns_tablet":"2","columns_mobile_extra":"1","item_normal_background_background":"classic","columns_mobile":1,"carousel_arrows_prev_arrow_vertical_top_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_mobile":{"unit":"%","size":"","sizes":[]},"wdt_animation_effect":"none"}'
                  data-widget_type="wdt-counter.default"
                >
                  <div className="elementor-widget-container">
                    <div
                      className="wdt-counter-holder wdt-content-item-holder wdt-column-holder wdt-rc-template-custom-template"
                      id="wdt-counter-0b1e21d"
                      data-settings=""
                    >
                      <div
                        className="wdt-column-wrapper wdt-column-gap-custom wdt-snap-scroll-enabled"
                        data-column-settings='{"columnDevices":["tablet_extra","tablet","mobile_extra","mobile"]}'
                        data-module-id="wdt-module-id-0b1e21d"
                        id="wdt-module-id-0b1e21d"
                      >
                        <div className="wdt-column">
                          <div className="wdt-content-item">
                            <div className="wdt-content-media-group">
                              <div className="wdt-content-title">
                                <h5>Students Graduated </h5>
                              </div>
                              <div className="wdt-content-counter-wrapper">
                                <div className="wdt-content-counter">
                                  <span
                                    className="wdt-content-counter-number"
                                    data-from={0}
                                    data-to={750}
                                    data-speed={1000}
                                    data-refresh-interval={100}
                                  >
                                    750
                                  </span>
                                  <span className="wdt-content-counter-suffix">
                                    K
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="wdt-content-detail-group">
                              <div className="wdt-content-description">
                                Donec sit amet turpis tincidunt eros, nam
                                porttitor massa leo porta maecenas reque.
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="wdt-column">
                          <div className="wdt-content-item">
                            <div className="wdt-content-media-group">
                              <div className="wdt-content-title">
                                <h5>Academic Programs</h5>
                              </div>
                              <div className="wdt-content-counter-wrapper">
                                <div className="wdt-content-counter">
                                  <span
                                    className="wdt-content-counter-number"
                                    data-from={0}
                                    data-to={289}
                                    data-speed={1000}
                                    data-refresh-interval={100}
                                  >
                                    289
                                  </span>
                                  <span className="wdt-content-counter-suffix">
                                    +
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="wdt-content-detail-group">
                              <div className="wdt-content-description">
                                Donec sit amet turpis tincidunt eros, nam
                                porttitor massa leo porta maecenas reque.
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="wdt-column">
                          <div className="wdt-content-item">
                            <div className="wdt-content-media-group">
                              <div className="wdt-content-title">
                                <h5>Global Awards </h5>
                              </div>
                              <div className="wdt-content-counter-wrapper">
                                <div className="wdt-content-counter">
                                  <span
                                    className="wdt-content-counter-number"
                                    data-from={0}
                                    data-to={85}
                                    data-speed={1000}
                                    data-refresh-interval={100}
                                  >
                                    85
                                  </span>
                                  <span className="wdt-content-counter-suffix">
                                    +
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="wdt-content-detail-group">
                              <div className="wdt-content-description">
                                Donec sit amet turpis tincidunt eros, nam
                                porttitor massa leo porta maecenas reque.
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="wdt-column">
                          <div className="wdt-content-item">
                            <div className="wdt-content-media-group">
                              <div className="wdt-content-title">
                                <h5>Schools Worldwide </h5>
                              </div>
                              <div className="wdt-content-counter-wrapper">
                                <div className="wdt-content-counter">
                                  <span
                                    className="wdt-content-counter-number"
                                    data-from={0}
                                    data-to={65}
                                    data-speed={1000}
                                    data-refresh-interval={100}
                                  >
                                    65
                                  </span>
                                  <span className="wdt-content-counter-suffix">
                                    +
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="wdt-content-detail-group">
                              <div className="wdt-content-description">
                                Donec sit amet turpis tincidunt eros, nam
                                porttitor massa leo porta maecenas reque.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="wdt-column-pagination wdt-snap-scroll-pagination"
                        style={{ display: "none" }}
                      >
                        <button className="wdt-pagination-prev wdt-module-id-0b1e21d">
                          Previous
                        </button>
                        <button className="wdt-pagination-next wdt-module-id-0b1e21d">
                          Next
                        </button>
                      </div>
                    </div>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  </div>
  )
}

export default Card